document.addEventListener('turbo:load', () => {
  let filterBtn = document.querySelector('#packages-filter .filter-btn, #packages-filter .btn-inverse.filter')
  let closeBtn = document.querySelector('#packages-filter .filter-heading .icon-cross, #packages-filter .icon-cross')

  if (filterBtn) {
    filterBtn.addEventListener('click', () => {
      document.querySelector('body').classList.add('no-scroll')
    })
  }
  
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('body').classList.remove('no-scroll')
    })
  }
})